import styled from "styled-components";

export const HList = styled.ul.attrs({
  className: "h-list",
})<{ $gap?: string; }>`
  list-style: none;
  display: flex;
  flex-direction: column;
  gap: ${({ $gap, }) => $gap || "0px" };
  li {
    display: flex;
    justify-content: space-between;
    align-items: center;
    grid-template-columns: 1fr 1fr;
  }
`;